/**
 * Dawn Theme — Load More Button
 * Replaces pagination with a "Load More" button that
 * fetches the next page and appends cards to the grid.
 * Works with sold-out filtering (sold-out-filter.js).
 */

(function () {
  'use strict';

  class LoadMore {
    constructor() {
      this.button     = document.getElementById('load-more-btn');
      this.grid       = document.getElementById('main-collection-product-grid');
      this.loading    = false;

      if (!this.button || !this.grid) return;

      this.currentPage  = parseInt(this.button.dataset.currentPage  || 1);
      this.totalPages   = parseInt(this.button.dataset.totalPages   || 1);
      this.baseUrl      = this.button.dataset.baseUrl || window.location.pathname;

      this.button.addEventListener('click', () => this.loadMore());
    }

    async loadMore() {
      if (this.loading) return;
      if (this.currentPage >= this.totalPages) {
        this.hide();
        return;
      }

      this.setLoading(true);
      const nextPage = this.currentPage + 1;

      try {
        // Build the URL for the next page — preserve sort and filters
        const params  = new URLSearchParams(window.location.search);
        params.set('page', nextPage);
        const url     = `${this.baseUrl}?${params.toString()}&section_id=${this.getSectionId()}`;

        const res     = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html    = await res.text();

        // Parse the response and extract just the grid items
        const parser  = new DOMParser();
        const doc     = parser.parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('main-collection-product-grid');

        if (!newGrid) throw new Error('Could not find product grid in response');

        const newItems = Array.from(newGrid.querySelectorAll('.grid__item'));

        if (newItems.length === 0) {
          this.hide();
          return;
        }

        // Append new items to the existing grid
        newItems.forEach(item => {
          item.style.opacity = '0';
          item.style.transform = 'translateY(1rem)';
          this.grid.appendChild(item);

          // Fade in
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            });
          });
        });

        this.currentPage = nextPage;
        this.button.dataset.currentPage = this.currentPage;

        // If we've reached the last page, hide the button
        if (this.currentPage >= this.totalPages) {
          this.hide();
        }

        // Re-run sold-out filter on newly added items if available
        if (window.soldOutFilter) {
          window.soldOutFilter.filterGrid(this.grid);
        }

      } catch (err) {
        console.error('[LoadMore] Failed to load more products:', err);
      } finally {
        this.setLoading(false);
      }
    }

    getSectionId() {
      return this.grid ? this.grid.dataset.id : '';
    }

    updateCounter() {
  if (!this.counter) return;
  const visible = this.grid.querySelectorAll('.grid__item:not([style*="display: none"])').length;
  const total   = parseInt(this.counter.dataset.total || 0);
  this.counter.textContent = `Showing ${visible} of ${total} products`;
}

    setLoading(state) {
      this.loading = state;
      this.button.classList.toggle('loading', state);
      this.button.disabled = state;
      this.button.textContent = state ? 'Loading...' : 'Load More';
    }

    hide() {
      if (this.button && this.button.parentElement) {
        this.button.parentElement.style.display = 'none';
      }
    }
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new LoadMore());
  } else {
    new LoadMore();
  }

})();
